export const classLevelOptions = classLevelList => {
  if (!classLevelList) {
    return [{ label: "--", value: "0" }];
  }

  return [
    { label: "--", value: "0" },
    ...classLevelList.map(val => ({
      label: val.in_text,
      value: val.id,
    })),
  ];
};

export const coachOptions = coachList => {
  if (!coachList) {
    return [{ label: "--", value: "0" }];
  }

  return [
    { label: "--", value: "0" },
    ...coachList.map(val => ({
      label: val.name,
      value: val.id,
    })),
  ];
};
